import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/auth/Login';
import { LogoutPage } from './pages/auth/Logout';
import Landing from './pages/Landing';
import AdminDashboard from './pages/admin/Dashboard';
import DebugPanel from './components/debug/DebugPanel';

// Protected route wrapper
const ProtectedRoute: React.FC<{
  element: React.ReactElement;
  requiredRole?: 'tedy-admin' | 'tedy-partner' | 'tedy-student';
}> = ({ element, requiredRole }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && (!user || user.role !== requiredRole)) {
    return <Navigate to="/" replace />;
  }

  return element;
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Layout>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/login/callback" element={<Login />} />
            <Route
              path="/logout"
              element={<ProtectedRoute element={<LogoutPage />} />}
            />

            {/* Admin routes */}
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute
                  element={<AdminDashboard />}
                  requiredRole="tedy-admin"
                />
              }
            />

            {/* Partner routes */}
            <Route
              path="/partner/dashboard"
              element={
                <ProtectedRoute
                  element={<div>Partner Dashboard</div>}
                  requiredRole="tedy-partner"
                />
              }
            />

            {/* Student routes */}
            <Route
              path="/student/dashboard"
              element={
                <ProtectedRoute
                  element={<div>Student Dashboard</div>}
                  requiredRole="tedy-student"
                />
              }
            />

            {/* Fallback route */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          {import.meta.env.DEV && <DebugPanel />}
        </Layout>
      </Router>
    </AuthProvider>
  );
};

export default App;
